<template>
  <div v-click-outside="handleClickOutSide" class="dropdown_container">
    <kw-button
      button-type="text"
      prepend-icon-class="kw kw-tag"
      class="button-action-bar"
      :disabled="disabled"
      data-cy="manage-keywords-tags-button"
      @click="handleButtonClick"
      @prepend-icon-mouseover="tooltip({ text: $t('manage-tags'), event: $event, disabled })"
    />
    <custom-dropdown-body ref="manageTagsDropDown">
      <manage-tags-container :apply-cb="close" />
    </custom-dropdown-body>
  </div>
</template>

<script>
import ToolTipRenderMixin from '@/mixins/ToolTipRenderMixin';
import ManageTagsContainer from './ManageTagsContainer';
export default {
  name: 'ManageTags',
  components: {
    'manage-tags-container': ManageTagsContainer,
  },
  mixins: [ToolTipRenderMixin],
  props: {
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  methods: {
    async handleButtonClick() {
      if (!this.$refs.manageTagsDropDown.getIsDropdownOpened) {
        this.$refs.manageTagsDropDown.openDropdown();
      } else {
        this.close();
      }
    },
    handleClickOutSide() {
      if (this.$refs.manageTagsDropDown?.getIsDropdownOpened) {
        this.close();
      }
    },
    close() {
      this.$refs.manageTagsDropDown.closeDropdown();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~sass/partials/action-bar';
</style>
